<template>
  <section class="section Notice">
    <div class="container">
      <div class="level">
        <h1 class="title level-left">Emergente</h1>
        <div class="switch_wrapper">
          <p>Visible </p>
          <label class="switch">
            <input type="checkbox" v-model="visible" @change="udpateState(visible)">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="card box">
        <div class="grid_inputs">
          <div class="dropzone_content">
              <img v-if="cover" :src="cover" />
              <input
                id="cover_main"
                style="display: none"
                type="file"
                ref="fileInput"
                @change="onFileChange($event)"
                accept="image/*"
              />
              <label v-if="cover"
                class="dropzone"
                @click="clearCover()"
                >
                <div class="open_file">
                  <div class="upload">
                    <ion-icon name="close" ></ion-icon>
                  </div>
                  <h1>
                    Cambiar Imagen
                  </h1>
                </div>
              </label>
              <label
                v-else-if="!cover"
                class="dropzone"
                for="cover_main"
                :class="{ready: fileInto}"
                @dragover.prevent="dragover($event)"
                @dragleave.prevent="dragleave($event)"
                @drop.prevent="dragFinish(-1,$event)"
              >
                <div class="open_file" v-if="!file.content">
                  <div class="upload">
                    <ion-icon name="cloud-upload-outline" ></ion-icon>
                  </div>
                  <h1>
                    Arrastrar y soltar imagen o
                    <strong>cargar</strong>
                  </h1>
                </div>
                <div class="file_selected" v-else>
                  <div class="upload">
                    <ion-icon name="image-outline"></ion-icon>
                  </div>
                  <h1>
                    <p>{{file.content.name}}</p>
                    <small>
                      {{(file.content.size / 1000 / 1000).toFixed(2)}} Mb
                      <b v-if="!validateSizeFile">( Archivo muy grande, Max: 20 Mb )</b>
                    </small>
                  </h1>
                </div>
              </label>
            </div>
          <div class="input_wrapper">
            <label>Titulo</label>
            <input class="input" type="text" placeholder="Titulo de aviso" v-model="title">
          </div>
          <div class="input_wrapper">
            <label>Mensaje</label>
            <textarea class="input" type="text" placeholder="Cuerpo del aviso" v-model="body"></textarea>
          </div>
          <button class="button is-warning is-rounded" :class="{'is-loading': loading}" @click.prevent="checkPhoto()">Guardar Aviso</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { firestore, storage } from '@/main'
export default {
  data: () => ({
    infoId: "",
    title: "",
    body: "",
    loading: false,
    visible: false,
    url: "",
    file: {
      content: null
    },
    cover: '',
    fileInto: false,
  }),
  mounted () {
    this.getWebInfo()
  },
  methods: {
    clearCover () {
      this.cover = ""
    },
    dragFinish (i, e) {
      this.file.content = e.dataTransfer.files[0]
      this.cover = URL.createObjectURL(e.dataTransfer.files[0]);
      this.fileInto = false
    },
    dragover () {
      this.fileInto = true
    },
    dragleave () {
      this.fileInto = false
    },
    onFileChange (e) {
      this.file.content = event.target.files[0];
      this.cover = URL.createObjectURL(e.target.files[0]);
    },
    checkPhoto () {
      if (this.file.content) this.uploadPhoto()
      else this.saveMessage(this.cover)
    },
    async uploadPhoto () {
      this.loading = true
      let metadata = { contentType: this.file.type }
      storage.ref('/notice').child("notice_image").put(this.file.content, metadata)
        .then(snapshot =>  snapshot.ref.getDownloadURL())
        .then(url => {
          console.log('imagen guardada', url)
          this.saveMessage(url)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getWebInfo () {
      firestore.collection("web").get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.infoId = doc.id
          const { modal: {title, body, visible, url} } = doc.data()
          this.title = title
          this.body = body
          this.visible = visible
          this.cover = url
          this.url = url
        })
      })
      .catch(console.error)
    },
    saveMessage(url) {
      console.log('url', url)
      this.loading = true
      firestore.collection("web").doc(this.infoId).update({
        modal: {
          title: this.title,
          body: this.body,
          visible: this.visible,
          url: url
        }
      })
      .then((res) => {
        console.log(res)
        this.loading = false
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      })
    },
    udpateState(visible) {
      firestore.collection("web").doc(this.infoId).update({
        modal: {
          title: this.title,
          body: this.body,
          visible,
          url: this.url
        }
      })
      .then((res) => {
        console.log(res)
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      })
    },
  },
  computed: {
    validateSizeFile () {
      return this.file.content.size / 1000 <= 20000
    },
  }
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../../assets/css/switch'

.Notice
  h1
    font-size: 20px
  .switch_wrapper
    display: flex
    align-items: center
    p
      margin-right: 10px
      font-size: 14px
  .grid_inputs
    display: grid
    grid-gap: 20px
    grid-template-columns: 1fr
    .button, .input
      box-sizing: border-box
    .button
      width: 200px
    .input_wrapper
      label
        font-size: 13px
        margin-bottom: 5px
        display: block
        font-weight: 600
      textarea
        height: 100px
    .dropzone_content
        width: 100%
        box-sizing: border-box
        position: relative
        .dropzone
          height: 400px
        img
          position: absolute
          left: 0
          top: 0
          width: 100%
          height: 100%
          object-fit: cover
          border-radius: 5px
          width: calc(100% - 30px)
          height: calc(100% - 30px)
          margin: 15px
        .dropzone
          width: 100%
          height: 350px
          background-color: transparent
          border-radius: 5px
          border: 1px dashed darken(#F4F7F8, 10%)
          display: flex
          justify-content: center
          align-items: center
          cursor: pointer
          transition: all ease-in-out .2s
          padding: 20px
          box-sizing: border-box
          position: relative
          z-index: 2
          .open_file, .file_selected
            display: flex
            align-items: center
            background-color: white
            padding: 7px
            padding-right: 25px
            border-radius: 30px
          .file_selected
            small
              font-size: 12px
              font-weight: 400
              margin-top: 2px
              display: block
              b
                color: red
          .upload
            background-color: darken(#F4F7F8, 5%)
            width: 40px
            min-width: 40px
            height: 40px
            border-radius: 50%
            display: flex
            justify-content: center
            align-items: center
            margin-right: 15px
            i
              color: #3273DC
          h1
            font-size: 14px
            font-weight: 500
            p
              line-height: 1.3
              overflow: hidden
              text-overflow: ellipsis
              display: -webkit-box
              -webkit-line-clamp: 1
              -webkit-box-orient: vertical
            strong
              color: #3273DC
          &.ready, &:hover
            background-color: rgba(#F4F7F8, .7)
            border: 1px dashed #3273DC
</style>